<template>
  <v-card flat>
    <v-card-text>
      <h3>À propos d'AGIL<sup>&reg;</sup></h3>
      <br />

      <p>
        Le site web disponible à l'adresse www.agil.maisondulait.fr a pour
        objectif de permettre aux collaborateurs des entités de la filière
        laitière présentes à la Maison du Lait (MDL), d'accéder au moyen d'un
        compte en ligne à l'Annuaire mutualisé de l'interprofession laitière
        (AGIL) regroupant les contacts professionnels internes et externes de la
        MDL.
      </p>

      <h3>Editeur</h3>
      <br />

      <p>Ce site web est édité par :</p>

      <p>
        Le Centre National Interprofessionnel de l'Economie Laitière (CNIEL),
        Association loi 1901, déclarée à la Préfecture de Paris le 8 avril 1974,
        enregistrée sous le n&deg;W751035614, 42, rue de Châteaudun, 75314 Paris
        Cedex 9
      </p>

      <p>Directeur de la publication: Madame Caroline LE POULTIER</p>

      <p>
        Pour toute question concernant ce site web, vous pouvez nous contacter à
        l'adresse suivante :<a href="mailto:contact@cniel.com"
          >contact@cniel.com</a
        >
      </p>

      <h3>Hébergement</h3>
      <br />

      <p>Le site est hébergé par:</p>

      <p>Maison du Lait Services - 42 rue de Châteaudun 75009 Paris</p>

      <p>Tel. : <a href="tel:+33149707111">+ 33 1 49 70 71 11</a></p>

      <p>Datacenter: Cloud Temple (France)</p>

      <h3>Protection des données personnelles</h3>
      <br />

      <p>
        Pour accéder à AGIL<strong><sup>&reg;</sup></strong
        >, des informations nominatives sont indispensables et doivent être
        renseignées par les gestionnaires du site au moment de la création du
        compte de l'utilisateur en ligne.
      </p>

      <p>
        Les données des utilisateurs sont réservées à l'usage exclusif des
        collaborateurs des entités de la filière laitière présentes à la MDL.
        Elles ne sont pas utilisées pour d'autres finalités et ne sont ni
        communiquées ni cédées à des organismes tiers.
      </p>

      <p>
        En savoir plus sur les données personnelles, vos droits et les moyens de
        les exercer en consultant notre page
        <a href="RGPD">&laquo;Données Personnelles&raquo;</a>.
      </p>

      <p>
        Pour toute demande sur les données personnelles, vous pouvez contacter à
        tout moment le délégué à la protection des données du CNIEL, selon les
        modalités suivantes:
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Par courrier électronique à l'adresse suivante :<a
            href="mailto:donneespersonnelles@cniel.com"
            >donneespersonnelles@cniel.com</a
          >;
        </li>
        <li>
          Par courrier postal: CNIEL - Service juridique - 42 rue de Châteaudun
          - 75009 Paris.
        </li>
      </ul>
      <br />

      <h3>Sécurité des comptes d'accès</h3>
      <br />

      <p>
        Afin d'assurer la confidentialité et la sécurité d'AGIL<strong
          ><em><sup>&reg;</sup></em></strong
        >, l'accès au système et aux données est réservé:
      </p>

      <p>
        - aux utilisateurs autorisés ayant un compte en ligne et assujettis à un
        engagement de confidentialité.
      </p>

      <p>
        L'accès d'un utilisateur au système se fait au moyen de codes d'accès
        personnels et confidentiels (identifiant et mot de passe). Ces codes
        d'accès, qui ne peuvent en aucun cas être communiqués à des tiers,
        permettent d'accéder aux données AGIL<strong
          ><em><sup>&reg;</sup></em></strong
        >.
      </p>

      <h3>Droits de propriété intellectuelle</h3>
      <br />

      <p>L'Editeur est propriétaire du site web.</p>

      <p>
        L'ensemble des contenus de ce site web est protégé par la législation
        française et internationale sur le droit d'auteur et la propriété
        intellectuelle. La reproduction de tout ou partie du site web,par
        quelque procédé que ce soit et au-delà d'un usage strictement privé, est
        formellement interdite, y compris pour les fichiers téléchargeables, les
        logiciels, les visuels d'illustration, les textes et les représentations
        photographiques, sauf autorisation expresse et préalable de l'Editeur.
      </p>

      <p>
        Les marques et logos, ainsi que les signes distinctifs figurant sur le
        site web, sont protégés par leurs propriétaires respectifs et ne peuvent
        être utilisés à une fin quelconque, sans l'autorisation préalable de ces
        derniers.
      </p>

      <p>
        Les bases de données de ce site websont protégées par les dispositions
        du Code de la propriété intellectuelle. Sont notamment interdites
        l'extraction et la réutilisation, quantitativement ou qualitativement
        substantielles, du contenu des bases de données AGIL. Tout contrevenant
        s'expose aux sanctions visées aux articles L 343-1 et suivants du Code
        de la propriété intellectuelle.
      </p>

      <h3>Garanties et responsabilités</h3>
      <br />

      <p>
        Les informations contenues sur le site web engagent la responsabilité de
        leur auteur et ne sauraient engager la responsabilité de l'Editeur
        lorsque ce dernier n'est pas l'auteur des informations.
      </p>

      <p>
        L'Editeur ne donne aucune garantie relative à l'utilisation du site web
        et ne saurait être responsable des dommages directs ou indirects
        découlant de son utilisation, notamment en cas d'interruption des accès,
        des services ou de pertes de données.
      </p>

      <h3>Crédits</h3>
      <br />

      <div style="display: flex; align-items: center">
        <img src="~@/assets/images/logo_astek.png" width="100px" />
        <p style="margin-left: 20px">
          Conception et réalisation du site web : Groupe ASTEK - Société Anonyme
          au capital de 422 349,00 € dont le siège social est situé à Les
          Patios, Bâtiment D - 77-81ter, rue Marcel Dassault - F-92100
          Boulogne-Billancourt - R.C.S. Nanterre 489 800805 -Téléphone :
          <a href="tel:+33188891768">+33 1 88 89 17 68</a>
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import admin from '@/../admin.json';

export default {
  data: () => ({
    valueContact:
      `Contactez-nous par voie électronique : ${admin.mail} \n` +
      `Contactez-nous par courrier postal : \n ${admin.adresse} \n` +
      `Contactez-nous par téléphone : ${admin.telephone}`,
  }),
};
</script>
